/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable camelcase */
import api from './api';

class FormService {

  postContato = (data: any) => {
    return api.post(`/core/contato-gomidia/`, data);
  };

}
export default FormService;
